import { render, staticRenderFns } from "./Delivery-Schedule.vue?vue&type=template&id=7e5136e5"
import script from "./Delivery-Schedule.vue?vue&type=script&lang=js"
export * from "./Delivery-Schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports